$(document).ready(function() {
  
/*
* Functions
* --------- */

// Image rollover
/*if($(".reveal").length) {
	$(".reveal").hover(function(){
		$(".reveal-over", this).stop().fadeTo(300, 1.0);
	},function(){
		$(".reveal-over", this).stop().fadeTo(300, 0);
	});
}*/

// Show/hide additional details
if( $('.additional-details').length ){
  $('.additional-details').hide();
  $('<button class="lightGreyButton full"><span class="append arrow">View more</span></button>').insertAfter('.additional-details').toggle(function (){
              $(this).html('<span class="append arrow flip">Close</span>').prev('.additional-details').slideDown(500);
          }, function(){
              $(this).html('<span class="append arrow">View more</span>').prev('.additional-details').slideUp(600);
          });
}


/*
* Initialization
* -------------- */

// Placeholder for IE
if($('input')) { $('input[placeholder], textarea[placeholder]').placeholder(); }

// Video popup
$(document).ready(function() {
	$(".various").fancybox({
		fitToView	: false,
		width		: 800,
		height		: 450,
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'fade',
		closeEffect	: 'none',
		padding		: 0
	});
});

// Home - Slideshow
if($(".home-slideshow").length) {
	$(".home-slideshow ul").carouFredSel({
		items 		: 1,
		auto : {
			fx: 'crossfade',
			duration	: 600,
            delay: 4000,
			pauseDuration: 4000,
			pauseOnHover: true
		},
		scroll : {
			fx: 'crossfade'
		},
		prev    : {
			key     : "left"
		},
		next    : {
			key     : "right"
		},
		pagination	: ".pagination"
	});
}

// Products - Slideshow
if($("#product-slideshow-items").length) {
	$("#product-slideshow-items").carouFredSel({
		items 		: 1,
		auto : {
			play: false
		},
		scroll : {
			fx: 'crossfade',
			wipe: true,
			onBefore: function(){
				scrollThumbnails($(this).triggerHandler( 'currentPosition' ), 3, true);
			}
		},
		prev: {
		  button: '#slideshow-nav-prev',
		  key: 'left'
		},
		next: {
		  button: '#slideshow-nav-next',
		  key: 'right'
		},
		pagination	: ".pagination"
	});
}

// Products - Mix'n'match slideshow
if($("#mixmatch-slideshow-items").length) {
	$("#mixmatch-slideshow-items").carouFredSel({
	  width: 685,
		height: 335 ,
		align: false,
		items: {
			width: 685,
			height: 310,
			visible: 1
		},
		auto: {
		  pauseDuration: 4000
		},
		scroll : {
			fx: 'crossfade'
		}
	});
}



if($('#product-thumbnails-items').length){
	$('#product-thumbnails-items').carouFredSel({
		circular: false,
		infinite: false,
		width: 735,
		height: 155,
		align: false,
		items: {
			width: 245,
			height: 155,
			visible: 3
		},
		scroll: {
			fx: "scroll",
			items: 1,
			duration: 600,
			easing: "easeInOutQuart"
		},
		auto: false,
		prev: '#thumbnail-nav-up',
		next: '#thumbnail-nav-down'
	});
}

if($('.product-thumbnails .product-thumbnail').length > 1)
  $('.product-thumbnails').height(155);

function scrollThumbnails(pos, nth, always){
	/* Everytime the main slideshow changes, it check to 
	make sure thumbnail and page are displayed correctly */
	/* Reset and select the current thumbnail item */
	$('.product-thumbnail.active').removeClass('active');
	$('#product-thumbnail-'+pos).addClass( 'active' );
	/* Move the thumbnail to the right page */
	var page = Math.floor( pos / nth );
	if(always == true || pos % nth == 0){
		$('#product-thumbnails-items').trigger( 'slideToPage', page);
	}	
}

});